import React from "react";
import CountUp from "react-countup";

const Card = ({ label, value, sub, icon, color, bg, isPct, valueColor }) => (
  <div className="relative overflow-hidden rounded-2xl bg-white ring-1 ring-black/[0.06] shadow-[0_1px_2px_rgba(16,24,40,0.04),0_4px_16px_rgba(16,24,40,0.04)] p-[18px]">
    <span
      className="absolute inset-x-0 top-0 h-[3px]"
      style={{ background: `linear-gradient(90deg, ${color}, ${color}00)` }}
    />
    <div className="flex items-center justify-between mb-3">
      <p className="text-[10.5px] text-gray-400 font-semibold uppercase tracking-[0.08em]">{label}</p>
      <span
        className="w-9 h-9 rounded-xl flex items-center justify-center"
        style={{ backgroundColor: bg, color }}
      >
        <i className={`fa-solid ${icon} text-[13px]`} />
      </span>
    </div>
    <p
      className="text-[1.5rem] font-bold leading-none tracking-tight tabular-nums"
      style={{ color: valueColor ?? "#111827" }}
    >
      <CountUp
        start={0}
        end={value}
        duration={1.1}
        separator=","
        decimals={2}
        prefix={isPct ? "" : "$"}
        suffix={isPct ? "%" : ""}
      />
    </p>
    {sub && <p className="text-[11px] text-gray-400 mt-2">{sub}</p>}
  </div>
);

const ProfitSummaryCards = ({ revenue = 0, expense = 0 }) => {
  const net = Math.round((revenue - expense) * 100) / 100;
  const margin = revenue > 0 ? Math.round((net / revenue) * 100 * 10) / 10 : 0;
  const positive = net >= 0;

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
      <Card
        label="Total Revenue"
        value={revenue}
        sub="Client invoices"
        icon="fa-money-bill-trend-up"
        color="#16A34A"
        bg="#F0FDF4"
      />
      <Card
        label="Total Expense"
        value={expense}
        sub="Engineer invoices"
        icon="fa-sack-dollar"
        color="#EF4444"
        bg="#FEF2F2"
      />
      <Card
        label="Net Profit"
        value={net}
        sub="Revenue − Expenses"
        icon="fa-scale-balanced"
        color="#0D9488"
        bg="#F0FDFA"
        valueColor={positive ? "#0D9488" : "#EF4444"}
      />
      <Card
        label="Profit Margin"
        value={margin}
        sub="Net profit ÷ revenue"
        icon="fa-percent"
        color="#4F46E5"
        bg="#EEF2FF"
        isPct
        valueColor={positive ? "#4F46E5" : "#EF4444"}
      />
    </div>
  );
};

export default ProfitSummaryCards;
